import * as RadixAvatar from "@radix-ui/react-avatar"
import { twMerge } from "tailwind-merge"

export function Avatar({
	src,
	alt,
	className,
}: {
	src?: string
	alt: string
	className?: string
}) {
	return (
		<RadixAvatar.Root
			className={twMerge(
				"flex size-16 overflow-hidden rounded-full bg-foreground/10",
				className,
			)}
		>
			<RadixAvatar.Image
				src={src}
				alt={alt}
				className="w-full h-full object-cover"
			/>
			<RadixAvatar.Fallback>
				<img src="/images/avatar-placeholder-iyk.png" alt={alt} className="size-full"/>
			</RadixAvatar.Fallback>
		</RadixAvatar.Root>
	)
}
